import { observable, action } from 'mobx'
import api from '../api'

class TestimonialsStore {

  @observable testimonials = []
  @observable loading = true

  constructor() {
    this.loadTestimonials()
  }

  @action.bound setTestimonials(testimonials) {
    this.testimonials = testimonials
  }

  @action.bound loadTestimonials() {
    this.loading = true
    api.Testimonials.getAll()
      .then( testimonials => {
        this.setTestimonials(testimonials)
      })
      .finally(action(() => { this.loading = false }))
  }

}

export default new TestimonialsStore()



// WEBPACK FOOTER //
// ./src/stores/testimonialsStore.js